import { reducerKey } from './RcsSupplierInfoReducer';


export function rcsSupplierInfo(state) {
  return state.get(reducerKey);
}
